<template>
  <LegalPage title="Privacy Policy" last-updated="August 30, 2025">
    <p>
      At Nilkhet Books, your privacy is important to us. This Privacy Policy
      explains how we collect, use, share, and protect your personal
      information when you visit our website, place an order, or otherwise
      interact with us. By using our website and services, you agree to the
      practices described in this policy.
    </p>

    <h2>1. Information We Collect</h2>
    <p>We collect the following types of information:</p>
    <ul>
      <li>
        <strong>Personal details</strong> you provide when creating an account
        or placing an order, such as your name, phone number, email address,
        and delivery address.
      </li>
      <li>
        <strong>Order and payment information</strong>: the books you purchase
        and the payment method used. Payments are processed securely through our
        payment partners (bKash, Nagad, and others); we do not store your full
        card or wallet credentials.
      </li>
      <li>
        <strong>Communication data</strong>: messages you send us through our
        contact form, email, phone, or social media.
      </li>
      <li>
        <strong>Technical data</strong>: such as your IP address, browser type,
        device information, and how you use our website, collected automatically
        through cookies and similar technologies.
      </li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>We use your information to:</p>
    <ul>
      <li>Process, fulfil, and deliver your orders.</li>
      <li>Communicate with you about your orders and provide customer support.</li>
      <li>Send order confirmations, delivery updates, and important notices.</li>
      <li>Improve our website, products, and services.</li>
      <li>
        Send you promotional offers and updates, where you have agreed to
        receive them. You can opt out at any time.
      </li>
      <li>Prevent fraud and comply with legal obligations.</li>
    </ul>

    <h2>3. Sharing Your Information</h2>
    <p>
      We do not sell your personal information. We only share it with trusted
      third parties who help us operate our business, including:
    </p>
    <ul>
      <li>Delivery and courier partners, to deliver your orders.</li>
      <li>Payment gateways, to process your transactions securely.</li>
      <li>
        Service providers who support our website and operations, under
        confidentiality obligations.
      </li>
      <li>
        Government or regulatory authorities, where required by law.
      </li>
    </ul>

    <h2>4. Cookies</h2>
    <p>
      Our website uses cookies to keep you logged in, remember items in your
      cart, understand how our site is used, and improve your experience. You can
      control or disable cookies through your browser settings, though some
      features of the site may not work properly without them.
    </p>

    <h2>5. Data Security</h2>
    <p>
      We take reasonable technical and organisational measures to protect your
      personal information against unauthorised access, loss, or misuse. However,
      no method of transmission over the internet is completely secure, and we
      cannot guarantee absolute security.
    </p>

    <h2>6. Your Rights</h2>
    <p>
      You may request access to, correction of, or deletion of your personal
      information at any time by contacting us. You may also unsubscribe from
      marketing communications using the link in our emails or by contacting us
      directly.
    </p>

    <h2>7. Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Any changes will be
      posted on this page with a revised "Last updated" date.
    </p>

    <h2>8. Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy or how we handle your
      data, please contact us:
    </p>
    <div class="highlight-box">
      <p>
        <strong>Nilkhet Books</strong><br />
        Shop 146, 1st Floor, Gausul Azam Super Market, Nilkhet, Dhaka 1205<br />
        Phone: <a href="tel:+8801711086468">+880 1711 086 468</a><br />
        Email:
        <a href="mailto:nilkhetdotcom@gmail.com">nilkhetdotcom@gmail.com</a>
      </p>
    </div>
  </LegalPage>
</template>

<script>
import LegalPage from "@/components/LegalPage.vue";

export default {
  name: "PrivacyPolicy",
  components: { LegalPage },
};
</script>
